import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UrgentDossier } from '../../types/dashboard.types';
import './UrgentCard.styles.css';

interface UrgentCardProps {
  urgentDossiers: UrgentDossier[];
}

export const UrgentCard: React.FC<UrgentCardProps> = ({ urgentDossiers }) => {
  const navigate = useNavigate();

  const handleDossierClick = (dossierId: string) => {
    navigate('/expert/a-traiter', { state: { filter: 'urgent' } });
  };

  return (
    <div className="dashboard-card urgent-card">
      <div className="dashboard-card-header">
        <h3 className="dashboard-card-title">Dossiers urgents</h3>
        {urgentDossiers.length > 0 && (
          <span className="info-badge info-badge--urgent">{urgentDossiers.length} urgents</span>
        )}
      </div>
      <div className="urgent-list">
        {urgentDossiers.length > 0 ? (
          urgentDossiers.map(dossier => (
            <div 
              key={dossier.id} 
              className="urgent-item clickable"
              onClick={() => handleDossierClick(dossier.id)}
            >
              <div className="urgent-ref">{dossier.ref}</div>
              <div className="urgent-property">{dossier.property}</div>
              <div className="urgent-deadline">
                <span className={`deadline-badge ${dossier.badgeType}`}>
                  {dossier.displayText}
                </span>
              </div>
            </div>
          ))
        ) : (
          <div className="empty-state">Aucun dossier urgent</div>
        )}
      </div>
    </div>
  );
};